import React from "react";
import moment from "moment";
import { MealPlanner } from "../../athlete-portal/nutrition/meal-planner/MealPlanner";
import { AddFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/AddFoodModal";
import { HandleFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/HandleFoodModal";
import { CreateNewFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/CreateNewFoodModal";
import { DuplicateMealPlanModal } from "../../athlete-portal/nutrition/meal-planner/modals/DuplicateMealPlanModal";
import { MoveMealPlanModal } from "../../athlete-portal/nutrition/meal-planner/modals/MoveMealPlanModal";
import { CustomMealModal } from "../../athlete-portal/nutrition/meal-planner/modals/CustomMealModal";
import { BuildMealModal } from "../../athlete-portal/nutrition/meal-planner/modals/BuildMealModal";
import CopyMealPlanFromTemplateModal from "../all-templates/modals/CopyMealPlanFromTemplateModal";
import DataSourceModal from "../../athlete-portal/nutrition/meal-planner/modals/DataSourceModal";

const EditMealPlanController = async ({ api, res, req, locals, load }) => {
  const { query } = req;

  const { mealPlan } = query;
  const modal = query.modal || {};
  const initialPromises = [
    load("mealPlan", {
      mealPlanId: mealPlan,
      proxyAthlete: null,
    }),
  ];

  if (locals.activeUser?.organizationId) {
    initialPromises.push(
      load("usersOrganization", {
        organizationId: locals.activeUser.organizationId,
      })
    );
  }

  await Promise.all(initialPromises);
  //we are request it after the promise all to have the organization information already loaded
  const nextPromises = [
    load("mostUsedMealPlans"),
    load("mealPlanIsTemplate", { mealPlanId: mealPlan }),
  ];

  switch (modal.type) {
    case "copy-meal-plan-from-template":
      nextPromises.push(
        load("mealPlanTemplates", {
          customLimit: 1,
          customSkip: 1,
          noPagination: true,
        }),
        load("assignedMealPlans")
      );
      break;
    case "create-meal-planner-food":
    case "build-meal":
      nextPromises.push(load("customFoods"));
      break;
    default:
      break;
  }
  await Promise.all(nextPromises);
  locals.modal = {
    "create-meal-planner-food": <AddFoodModal locals={locals} api={api} />, //main modal
    "handle-meal-planner-food": <HandleFoodModal locals={locals} />, //create-edit a food
    "create-new-food": <CreateNewFoodModal />, //modal to show 2 options (create a food or meal)
    "duplicate-meal-plan": <DuplicateMealPlanModal locals={locals} />, //duplicate a meal plan
    "move-meal-plan": <MoveMealPlanModal locals={locals} />, //move a meal plan
    "custom-meal": <CustomMealModal locals={locals} />, //modal to create cutom meals (something different as "snacks", "lunch", "breakfast")
    "build-meal": <BuildMealModal locals={locals} api={api} />, //create and edit a meal
    "data-source": <DataSourceModal locals={locals} />,
    "copy-meal-plan-from-template": (
      <CopyMealPlanFromTemplateModal locals={locals} />
    ),
  }[modal.type];

  res.body = <MealPlanner locals={locals} />;
};

export default EditMealPlanController;
